import { ADD_FLASH_MESSAGE, CLEAR_FLASH_MESSAGE, ADD_FLASH_MESSAGE_SUCCESS } from '../actions'


const flashMessageDefaults = {
  message: ''
}
export const flashMessageReducer = function (state = flashMessageDefaults, action) {
  switch (action.type) {
    case ADD_FLASH_MESSAGE:
      return { message: action.payload }
    case ADD_FLASH_MESSAGE_SUCCESS:
      return { message: action.payload, success: true }
    case CLEAR_FLASH_MESSAGE:
      return flashMessageDefaults
    default:
      return state
  }
}